// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FilterTag_wrapper__yTmqd","closeButton":"FilterTag_closeButton__12QVY","bodyFilterTag":"FilterTag_bodyFilterTag__SOHbf"};